import { coreApi } from '../core'
import { BlueprintFamilyExampleImage } from './exampleImages'

// Response shape for POST /blueprint-families/{id}/enrichment.
// Mirrors BE BlueprintFamilyEnrichmentRespDto: analyst-curated example screenshots, each
// picked from the live event it came from. MAY be empty for blueprints whose images
// haven't been populated yet (render an empty state, not broken imgs). Entries the BE can
// no longer resolve against their event are omitted rather than returned unlinked.
export type BlueprintFamilyEnrichmentApiResponse = {
  glossaryImages: BlueprintFamilyExampleImage[]
}

type GetBlueprintFamilyEnrichmentQueryParams = {
  blueprintFamilyId: string
}

const enrichmentApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST (GR-2916, was GET). The BE reads only the family id in the path; query
    // parameters and the request body are ignored, so none are sent.
    getBlueprintFamilyEnrichment: builder.query<BlueprintFamilyEnrichmentApiResponse, GetBlueprintFamilyEnrichmentQueryParams>({
      query: ({ blueprintFamilyId }) => ({
        url: `blueprint-families/${blueprintFamilyId}/enrichment`,
        method: 'POST',
      }),
      providesTags: (_result, _err, { blueprintFamilyId }) => [
        {
          type: 'BlueprintFamilies',
          id: `${blueprintFamilyId}/enrichment`,
        },
      ],
    }),
  }),
})

export const { useGetBlueprintFamilyEnrichmentQuery } = enrichmentApi
